import { Stack } from "@fluentui/react";
import React, { useRef } from "react";
import { AppTheme } from "./App";

interface InputProps {
  theme: AppTheme;
  currentNames: string[];
  onShowWheel: (finalNames: string[]) => void;
  trioMode: boolean;
  onToggleTrioMode: () => void;
}

const Input: React.FC<InputProps> = (props) => {
  const [names, setNames] = React.useState<string[]>([]);
  const debounceTimerRef = useRef<NodeJS.Timeout | null>(null);

  React.useEffect(() => {
    const initialNames = props.currentNames.length === 0 || props.currentNames[props.currentNames.length - 1] !== "" 
                        ? props.currentNames.concat("") 
                        : props.currentNames;
    setNames(initialNames);
  }, [props.currentNames]);

  // const onChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
  //     const names = e.target.value.split('\n');
  //     console.log(names)
  //     localStorage.setItem('names', JSON.stringify(names.filter(name => name !== '').map(name => name.trim()).flat()));
  //     setNames(names);
  // }

  const setValue = (index: number, value: string) => {
    const newNames = [...names];
    newNames[index] = value.replace("\n", "");

    if (index === newNames.length - 1 && value !== "") {
      newNames.push("");
    }
    else if (index < newNames.length - 1 && value === "" && newNames[index+1] === "") {
       newNames.splice(index, 1);
    }

    setNames(newNames);

    if (debounceTimerRef.current) {
      clearTimeout(debounceTimerRef.current);
    }

    debounceTimerRef.current = setTimeout(() => {
      const validNames = newNames.filter((name) => name.trim() !== "");
      const trimmedNames = validNames.map((name) => name.trim());

      localStorage.setItem("names", JSON.stringify(trimmedNames));

      const encodedNames: string[] = trimmedNames.map(encodeURIComponent);
      const urlParams: string = encodedNames.join(",");
      const newUrl = `?theme=${props.theme}&default=${urlParams}`;
      window.history.pushState({ path: newUrl }, "", newUrl);

    }, 500);
  };

  const handleKeyPress = (
    index: number,
    event: React.KeyboardEvent<HTMLTextAreaElement>
  ) => {
    switch (event.key) {
      case "Enter":
      case "ArrowDown":
        event.preventDefault();
        const nextIndex = index + 1;
        if (nextIndex < names.length) {
          document.getElementById(`textbox-${nextIndex}`)!.focus();
        }
        break;
      case "Backspace":
      case "Delete":
        if (names![index]) {
          return;
        }
        if (index === names.length - 1) {
          return;
        }
        const newNames = [...names];
        newNames.splice(index, 1);
        setNames(newNames);
        if (index > 0) {
          document.getElementById(`textbox-${index - 1}`)!.focus();
        }
        break;
      case "ArrowUp":
        event.preventDefault();
        if (index > 0) {
          document.getElementById(`textbox-${index - 1}`)!.focus();
        }
        break;
      default:
        break;
    }
  };

  const handleCreateWheel = () => {
    const createButton = document.getElementById("create-button");
    if (createButton) {
      createButton.textContent = "Skapar...";
    }

    if (debounceTimerRef.current) {
        clearTimeout(debounceTimerRef.current);
    }
    
    const finalValidNames = names.filter((name) => name.trim() !== "");
    const finalTrimmedNames = finalValidNames.map((name) => name.trim());

    localStorage.setItem(
      "names",
      JSON.stringify(finalTrimmedNames)
    );
    
    const encodedNames: string[] = finalTrimmedNames.map(encodeURIComponent);
    const urlParams: string = encodedNames.join(",");
    const finalUrl = `?theme=${props.theme}&default=${urlParams}`;
    window.history.pushState({ path: finalUrl }, "", finalUrl);

    props.onShowWheel(finalTrimmedNames);
  };

  return (
    <div className="input-container">
      <div 
        className="name-input-area" 
      >
        {names.map((name, index) => {
          return (
            <textarea
              key={`textbox-${index}`}
              id={`textbox-${index}`}
              className="TextRow"
              rows={1}
              cols={25}
              value={name}
              onChange={(e) => setValue(index, e.target.value)}
              onKeyUp={(e) => handleKeyPress(index, e)}
              placeholder="Lägg till ett namn här"
            />
          );
        })}
      </div>
      {/* Add mode indicator text */}
      <p className="mode-indicator">
        Nuvarande läge: {props.trioMode ? "Trio" : "Par"}
      </p>
      <div className="button-container">
        <button
          id="create-button"
          className={`Button ${props.theme}-button show-wheel-button`}
          onClick={handleCreateWheel}
        >
          Visa Fikahjulet!
        </button>
        <button 
          id="toggle-trio-button"
          className={`Button ${props.theme}-button toggle-trio-button`}
          onClick={props.onToggleTrioMode}
          style={{ display: 'inline-flex', alignItems: 'center', justifyContent: 'center' }}
        >
          <svg xmlns="http://www.w3.org/2000/svg" height="20px" viewBox="0 0 24 24" width="20px" fill="currentColor" style={{ marginRight: '0.5rem' }}>
            <path d="M0 0h24v24H0V0z" fill="none"/>
            <path d="M16 11c1.66 0 2.99-1.34 2.99-3S17.66 5 16 5s-3 1.34-3 3 1.34 3 3 3zm-8 0c1.66 0 2.99-1.34 2.99-3S9.66 5 8 5 5 6.34 5 8s1.34 3 3 3zm0 2c-2.33 0-7 1.17-7 3.5V19h14v-2.5c0-2.33-4.67-3.5-7-3.5zm8 0c-.29 0-.62.02-.97.05 1.16.84 1.97 1.97 1.97 3.45V19h6v-2.5c0-2.33-4.67-3.5-7-3.5z"/>
          </svg>
          {/* Conditional Button Text */}
          {props.trioMode ? "Byt till parläge" : "Byt till trioläge"} 
        </button>
      </div>
    </div>
  );
};

export default Input;
